__turbopack_context__.v({
  "container": "Drawer-module-scss-module__mGHPmq__container",
  "fullScreen": "Drawer-module-scss-module__mGHPmq__fullScreen",
  "noBlur": "Drawer-module-scss-module__mGHPmq__noBlur",
  "overlay": "Drawer-module-scss-module__mGHPmq__overlay",
});
